import React, { useState } from "react";
import { makeStyles } from "@material-ui/core";
import Moment from "moment";
import {
  Dialog,
  DialogTitle,
  IconButton,
  DialogContent,
  DialogContentText,
  DialogActions,
} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/CloseOutlined";
import { Slide } from "@material-ui/core";
import { getSignedUrl } from "../../Monitors/_redux/monitorCrud";
import { ProgressBar } from "react-bootstrap";
import { ReactComponent as PlayIcon } from "../../../../icons/play_icon.svg";
import { ReactComponent as PauseIcon } from "../../../../icons/pause_icon.svg";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});

const useStyles = makeStyles((theme) => ({
  input: {},
  root: {
    "& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline": {
      borderColor: "#158380",
    },
  },
  alertMsg: {
    color: "red",
  },
  MuiBackdrop: {
    backgroundColor: "rgba(0,0,0,0.6)",
  },
}));

function AudioPlayPopup(props) {
  const classes = useStyles();
  const [disabled, setdisabled] = useState(false);
  const [state, setState] = useState({
    audioPause: null,
    audioSelectedChannel: "",
    audioTimer: 0,
    progressTimeA: 0,
    completeTimeA: 0,
    progressTimeB: 0,
    completeTimeB: 0,
  });
  const [responseStatus, setResponse] = useState(false);
  const [errorMsg, setMessage] = useState("");

  const disableMessage = () => {
    setResponse(false);
  };
  const enableMessage = () => {
    setResponse(true);
  };

  const [audioA] = useState(new Audio());
  const [audioB] = useState(new Audio());
  let progress = 0;
  let duration = 0;
  const dummyChannelPlay = (id, opt) => {};
  const audioPlay = (id, opt) => {
    setState({
      ...state,
      audioPause: id,
      audioTimer: progress,
      audioSelectedChannel: opt,
    });

    if (opt !== state.audioPause) {
      let url;
      audioA.ontimeupdate = () => {
        setState({
          ...state,
          audioTimer: 0,
        });
      };
      audioB.ontimeupdate = () => {
        setState({
          ...state,
          audioTimer: 0,
        });
      };
      getSignedUrl(id)
        .then((res) => {
          if (res.data.status) {
            url = res.data.data[0].url;
            disableMessage();
            if (opt === "A") {
              audioB.pause();
              audioA.src = url;
              audioA.load();
              setdisabled(true);
              audioA.play().catch(function() {});
              setTimeout(() => {
                setdisabled(false);
              }, 1500);
              audioA.ontimeupdate = () => {
                let ct = audioA.currentTime;
                duration = audioA.duration;
                console.log("Duration", duration);
                if (isNaN(audioA.duration)) {
                  duration = 0;
                } else {
                  duration = audioA.duration;
                }
                progress = Math.floor((ct * 100) / duration);
                let minutes = "0" + parseInt(duration / 60, 10);
                let seconds = "0" + parseInt(duration % 60);
                const durationASec = minutes + ":" + seconds.slice(-2);
                let minutesCT = "0" + parseInt(audioA.currentTime / 60, 10);
                let secondsCT = "0" + parseInt(audioA.currentTime % 60);
                const currentTimeASec = minutesCT + ":" + secondsCT.slice(-2);
                setState({
                  ...state,
                  audioPause: opt,
                  audioTimer: progress,
                  audioSelectedChannel: opt,
                  progressTimeA: currentTimeASec,
                  completeTimeA: durationASec,
                });
              };
            } else if (opt === "B") {
              audioA.pause();
              audioB.src = url;
              audioB.load();
              setdisabled(true);
              audioB.play().catch(function() {});
              setTimeout(() => {
                setdisabled(false);
              }, 1500);
              audioB.ontimeupdate = () => {
                let ct = audioB.currentTime;
                let durationB = audioB.duration;
                if (isNaN(audioB.duration)) {
                  durationB = 0;
                } else {
                  durationB = audioB.duration;
                }
                progress = Math.floor((ct * 100) / durationB);
                let minutes = "0" + parseInt(durationB / 60, 10);
                let seconds = "0" + parseInt(durationB % 60);
                const durationBSec = minutes + ":" + seconds.slice(-2);
                let minutesCT = "0" + parseInt(audioB.currentTime / 60, 10);
                let secondsCT = "0" + parseInt(audioB.currentTime % 60);
                const currentTimeBSec = minutesCT + ":" + secondsCT.slice(-2);
                setState({
                  ...state,
                  audioPause: opt,
                  audioTimer: progress,
                  audioSelectedChannel: opt,
                  progressTimeB: currentTimeBSec,
                  completeTimeB: durationBSec,
                });
              };
            }
          } else {
            enableMessage();
            setMessage(res.data.message);
          }
        })
        .catch((error) => {
          enableMessage();
          if (error.response) {
            if (
              error.response !== null &&
              error.response !== undefined &&
              error.response.data.statusCode !== 500 &&
              error
            ) {
              console.log("Error Message ******", error.response.data.message);
              setMessage(error.response.data.message);
            } else {
              props.history.push("error/error-v1");
            }
          } else {
            setMessage(error.message);
          }
        });
    } else {
      if (opt === "A") {
        audioA.play(audioA.currentTime);
      } else if (opt === "B") {
        audioB.play(audioB.currentTime);
      }
    }
  };

  const audioPauseChannel = (opt) => {
    if (opt === "A") {
      audioA.pause();
    } else if (opt === "B") {
      audioB.pause();
    }
    setState({
      ...state,
      audioPause: opt,
    });
  };

  const cancel = (opt) => {
    audioA.pause();
    audioB.pause();
    props.onHide("cancel");
  };
  const DummyBChannel = (props) => {
    const { message } = props;
    return (
      <div className="audio-player-div">
        <div className="text">
          <p className="cha-name">Channel B</p>
        </div>
        <div className={disabled ? "player-box disabled" : "player-box"}>
          <PlayIcon onClick={(e) => {}} />

          <ProgressBar now={null} disabled={false} />
        </div>
        <p style={{ color: "red", padding: 10 }}>{message}</p>
      </div>
    );
  };
  const dummyChannelPause = (opt) => {};
  const DummyAChannel = (props) => {
    const { message } = props;
    return (
      <div className="audio-player-div">
        <div className="text">
          <p className="cha-name">Channel A</p>
        </div>
        <div className={disabled ? "player-box disabled" : "player-box"}>
          <PlayIcon onClick={(e) => {}} />

          <ProgressBar now={null} disabled={false} />
        </div>
        <p style={{ color: "red", padding: 10 }}>{message}</p>
      </div>
    );
  };
  var zone_name = Moment.tz.guess();
  var timezone = Moment.tz(zone_name).zoneAbbr();
  return (
    <div>
      <Dialog
        PaperProps={{}}
        className={classes.MuiBackdrop + " popupstyle play-popup"}
        disableBackdropClick
        TransitionComponent={Transition}
        keepMounted
        fullWidth={true}
        maxWidth="sm"
        open={props.show}
        onClose={cancel}
        scroll="paper"
        aria-labelledby="scroll-dialog-title"
        aria-describedby="scroll-dialog-description"
      >
        <div className="dialogTitle">
          <DialogTitle id="scroll-dialog-title">
            <span className="dialogtitle">Audio Player</span>
          </DialogTitle>

          <IconButton onClick={cancel} aria-label="close" className="closebtn">
            <CloseIcon />
            close
          </IconButton>
        </div>

        <DialogContent>
          <DialogContentText
            component="div"
            id="scroll-dialog-description"
            tabIndex={-1}
          >
            <div className="para-box">
              <p className="monitor-name">{props.file.monitor_id}</p>
              <p className="code-name">{props.file.code_name}</p>
              <p className="date">
                Audio uploaded:{" "}
                {Moment(props.file.created_date).format("MM-DD-yyyy, HH:mm:ss")}{" "}
                {timezone}
              </p>
            </div>

            <div className="progress-box">
              {props.file.file_data && props.file.file_data.length === 1 ? (
                <div className="single-player">
                  {props.file.file_data[0].channel === "A" &&
                  props.file.file_data[0].probe_status == "A" ? (
                    <div>
                      <div className="audio-player-div">
                        <div className="text">
                          <p className="cha-name">
                            Channel {props.file.file_data[0].channel}
                          </p>
                          {state.audioSelectedChannel ===
                            props.file.file_data[0].channel &&
                          state.audioTimer !== 0 ? (
                            <p className="timestamp">
                              {state.progressTimeA} of {state.completeTimeA}{" "}
                            </p>
                          ) : null}
                        </div>
                        <div
                          className={
                            disabled ? "player-box disabled" : "player-box"
                          }
                        >
                          {audioA.paused ? (
                            <PlayIcon
                              onClick={(e) => {
                                audioA.paused
                                  ? audioPlay(
                                      props.file.file_data[0].id,
                                      props.file.file_data[0].channel
                                    )
                                  : audioPauseChannel(
                                      props.file.file_data[0].channel
                                    );
                              }}
                            />
                          ) : (
                            <PauseIcon
                              onClick={(e) => {
                                audioA.paused
                                  ? audioPlay(
                                      props.file.file_data[0].id,
                                      props.file.file_data[0].channel
                                    )
                                  : audioPauseChannel(
                                      props.file.file_data[0].channel
                                    );
                              }}
                            />
                          )}

                          <ProgressBar
                            now={
                              state.audioSelectedChannel ===
                              props.file.file_data[0].channel
                                ? state.audioTimer
                                : 0
                            }
                          />
                        </div>
                      </div>
                      <DummyBChannel message="Probe not Connected" />
                    </div>
                  ) : props.file.file_data[0].channel === "B" &&
                    props.file.file_data[0].probe_status == "B" ? (
                    <div>
                      <DummyAChannel message="Probe not Connected" />
                      <div className="audio-player-div">
                        <div className="text">
                          <p className="cha-name">
                            Channel {props.file.file_data[0].channel}
                          </p>
                          {state.audioSelectedChannel ===
                            props.file.file_data[0].channel &&
                          state.audioTimer !== 0 ? (
                            <p className="timestamp">
                              {state.progressTimeB} of {state.completeTimeB}{" "}
                            </p>
                          ) : null}
                        </div>
                        <div
                          className={
                            disabled ? "player-box disabled" : "player-box"
                          }
                        >
                          {audioB.paused ? (
                            <PlayIcon
                              onClick={(e) => {
                                audioB.paused
                                  ? audioPlay(
                                      props.file.file_data[0].id,
                                      props.file.file_data[0].channel
                                    )
                                  : audioPauseChannel(
                                      props.file.file_data[0].channel
                                    );
                              }}
                            />
                          ) : (
                            <PauseIcon
                              onClick={(e) => {
                                audioB.paused
                                  ? audioPlay(
                                      props.file.file_data[0].id,
                                      props.file.file_data[0].channel
                                    )
                                  : audioPauseChannel(
                                      props.file.file_data[0].channel
                                    );
                              }}
                            />
                          )}

                          <ProgressBar
                            now={
                              state.audioSelectedChannel ===
                              props.file.file_data[0].channel
                                ? state.audioTimer
                                : 0
                            }
                          />
                        </div>
                      </div>
                    </div>
                  ) : props.file.file_data[0].probe_status == "AB" &&
                    props.file.file_data[0].channel === "A" ? (
                    <div>
                      <div className="audio-player-div">
                        <div className="text">
                          <p className="cha-name">
                            Channel {props.file.file_data[0].channel}
                          </p>
                          {state.audioSelectedChannel ===
                            props.file.file_data[0].channel &&
                          state.audioTimer !== 0 ? (
                            <p className="timestamp">
                              {state.progressTimeA} of {state.completeTimeA}{" "}
                            </p>
                          ) : null}
                        </div>
                        <div
                          className={
                            disabled ? "player-box disabled" : "player-box"
                          }
                        >
                          {audioA.paused ? (
                            <PlayIcon
                              onClick={(e) => {
                                audioA.paused
                                  ? audioPlay(
                                      props.file.file_data[0].id,
                                      props.file.file_data[0].channel
                                    )
                                  : audioPauseChannel(
                                      props.file.file_data[0].channel
                                    );
                              }}
                            />
                          ) : (
                            <PauseIcon
                              onClick={(e) => {
                                audioA.paused
                                  ? audioPlay(
                                      props.file.file_data[0].id,
                                      props.file.file_data[0].channel
                                    )
                                  : audioPauseChannel(
                                      props.file.file_data[0].channel
                                    );
                              }}
                            />
                          )}

                          <ProgressBar
                            now={
                              state.audioSelectedChannel ===
                              props.file.file_data[0].channel
                                ? state.audioTimer
                                : 0
                            }
                          />
                        </div>
                      </div>
                      <DummyBChannel message="Audio not received. Please check monitor." />
                    </div>
                  ) : props.file.file_data[0].probe_status == "AB" &&
                    props.file.file_data[0].channel === "B" ? (
                    <div>
                      <DummyAChannel message="Audio not received. Please check monitor." />
                      <div className="audio-player-div">
                        <div className="text">
                          <p className="cha-name">
                            Channel {props.file.file_data[0].channel}
                          </p>
                          {state.audioSelectedChannel ===
                            props.file.file_data[0].channel &&
                          state.audioTimer !== 0 ? (
                            <p className="timestamp">
                              {state.progressTimeB} of {state.completeTimeB}{" "}
                            </p>
                          ) : null}
                        </div>
                        <div
                          className={
                            disabled ? "player-box disabled" : "player-box"
                          }
                        >
                          {audioB.paused ? (
                            <PlayIcon
                              onClick={(e) => {
                                audioB.paused
                                  ? audioPlay(
                                      props.file.file_data[0].id,
                                      props.file.file_data[0].channel
                                    )
                                  : audioPauseChannel(
                                      props.file.file_data[0].channel
                                    );
                              }}
                            />
                          ) : (
                            <PauseIcon
                              onClick={(e) => {
                                audioB.paused
                                  ? audioPlay(
                                      props.file.file_data[0].id,
                                      props.file.file_data[0].channel
                                    )
                                  : audioPauseChannel(
                                      props.file.file_data[0].channel
                                    );
                              }}
                            />
                          )}

                          <ProgressBar
                            now={
                              state.audioSelectedChannel ===
                              props.file.file_data[0].channel
                                ? state.audioTimer
                                : 0
                            }
                          />
                        </div>
                      </div>
                    </div>
                  ) : (
                    <></>
                  )}
                </div>
              ) : props.file.file_data[0].probe_status == "AB" &&
                props.file.file_data.length === 2 ? (
                <div>
                  {props.file.file_data[0].channel === "A" ? (
                    <div>
                      <div className="audio-player-div">
                        <div className="text">
                          <p className="cha-name">
                            Channel {props.file.file_data[0].channel}
                          </p>
                          {state.audioSelectedChannel === "A" &&
                          state.audioTimer !== 0 ? (
                            <p className="timestamp">
                              {state.progressTimeA} of {state.completeTimeA}{" "}
                            </p>
                          ) : null}
                        </div>
                        <div
                          className={
                            disabled ? "player-box disabled" : "player-box"
                          }
                        >
                          {audioA.paused ? (
                            <PlayIcon
                              onClick={(e) => {
                                audioA.paused
                                  ? audioPlay(
                                      props.file.file_data[0].id,
                                      props.file.file_data[0].channel
                                    )
                                  : audioPauseChannel("A");
                              }}
                            />
                          ) : (
                            <PauseIcon
                              onClick={(e) => {
                                audioA.paused
                                  ? audioPlay(
                                      props.file.file_data[0].id,
                                      props.file.file_data[0].channel
                                    )
                                  : audioPauseChannel("A");
                              }}
                            />
                          )}

                          <ProgressBar
                            now={
                              state.audioSelectedChannel ===
                              props.file.file_data[0].channel
                                ? state.audioTimer
                                : 0
                            }
                          />
                        </div>
                      </div>
                      <div className="audio-player-div">
                        <div className="text">
                          <p className="cha-name">
                            Channel {props.file.file_data[1].channel}
                          </p>
                          {state.audioSelectedChannel === "B" &&
                          state.audioTimer !== 0 ? (
                            <p className="timestamp">
                              {state.progressTimeB} of {state.completeTimeB}{" "}
                            </p>
                          ) : null}
                        </div>
                        <div
                          className={
                            disabled ? "player-box disabled" : "player-box"
                          }
                        >
                          {audioB.paused ? (
                            <PlayIcon
                              onClick={(e) => {
                                audioB.paused
                                  ? audioPlay(
                                      props.file.file_data[1].id,
                                      props.file.file_data[1].channel
                                    )
                                  : audioPauseChannel("B");
                              }}
                            />
                          ) : (
                            <PauseIcon
                              onClick={(e) => {
                                audioB.paused
                                  ? audioPlay(
                                      props.file.file_data[1].id,
                                      props.file.file_data[1].channel
                                    )
                                  : audioPauseChannel("B");
                              }}
                            />
                          )}

                          <ProgressBar
                            now={
                              state.audioSelectedChannel ===
                              props.file.file_data[1].channel
                                ? state.audioTimer
                                : 0
                            }
                          />
                        </div>
                      </div>
                    </div>
                  ) : props.file.file_data[0].channel === "B" ? (
                    <div>
                      <div className="audio-player-div">
                        <div className="text">
                          <p className="cha-name">
                            Channel {props.file.file_data[0].channel}
                          </p>
                          {state.audioSelectedChannel === "B" &&
                          state.audioTimer !== 0 ? (
                            <p className="timestamp">
                              {state.progressTimeB} of {state.completeTimeB}{" "}
                            </p>
                          ) : null}
                        </div>
                        <div
                          className={
                            disabled ? "player-box disabled" : "player-box"
                          }
                        >
                          {audioB.paused ? (
                            <PlayIcon
                              onClick={(e) => {
                                audioB.paused
                                  ? audioPlay(
                                      props.file.file_data[0].id,
                                      props.file.file_data[0].channel
                                    )
                                  : audioPauseChannel("B");
                              }}
                            />
                          ) : (
                            <PauseIcon
                              onClick={(e) => {
                                audioB.paused
                                  ? audioPlay(
                                      props.file.file_data[0].id,
                                      props.file.file_data[0].channel
                                    )
                                  : audioPauseChannel("B");
                              }}
                            />
                          )}

                          <ProgressBar
                            now={
                              state.audioSelectedChannel ===
                              props.file.file_data[0].channel
                                ? state.audioTimer
                                : 0
                            }
                          />
                        </div>
                      </div>
                      <div className="audio-player-div">
                        <div className="text">
                          <p className="cha-name">
                            Channel {props.file.file_data[1].channel}
                          </p>
                          {state.audioSelectedChannel === "A" &&
                          state.audioTimer !== 0 ? (
                            <p className="timestamp">
                              {state.progressTimeA} of {state.completeTimeA}{" "}
                            </p>
                          ) : null}
                        </div>
                        <div
                          className={
                            disabled ? "player-box disabled" : "player-box"
                          }
                        >
                          {audioA.paused ? (
                            <PlayIcon
                              onClick={(e) => {
                                audioA.paused
                                  ? audioPlay(
                                      props.file.file_data[1].id,
                                      props.file.file_data[1].channel
                                    )
                                  : audioPauseChannel("A");
                              }}
                            />
                          ) : (
                            <PauseIcon
                              onClick={(e) => {
                                audioA.paused
                                  ? audioPlay(
                                      props.file.file_data[1].id,
                                      props.file.file_data[1].channel
                                    )
                                  : audioPauseChannel("A");
                              }}
                            />
                          )}

                          <ProgressBar
                            now={
                              state.audioSelectedChannel ===
                              props.file.file_data[1].channel
                                ? state.audioTimer
                                : 0
                            }
                          />
                        </div>
                      </div>
                    </div>
                  ) : null}
                </div>
              ) : (
                <></>
              )}
              <div className="col-xs-12" align="center">
                {responseStatus ? (
                  <div className={`d-flex p-2 ${classes.alertMsg}`}>
                    {errorMsg}
                  </div>
                ) : (
                  ""
                )}
              </div>
            </div>
          </DialogContentText>
        </DialogContent>
        <DialogActions className="one-btn">
          <button className="saveButton" onClick={cancel}>
            Done
          </button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
export default AudioPlayPopup;
